import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { Shield, CheckCircle } from 'lucide-react';
export function GuaranteeSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="bg-white py-16 px-4" data-id="element-115">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.6
    }} className="max-w-4xl mx-auto" data-id="element-116">
        <div className="bg-gradient-to-br from-green-50 to-emerald-50 border-2 border-green-400 rounded-2xl p-8 md:p-12 shadow-xl" data-id="element-117">
          <div className="flex flex-col items-center text-center" data-id="element-118">
            <img src="https://cdn.magicpatterns.com/uploads/qAwxMDe4CsKf49aLfC7XEp/logo_de_garantia.png" alt="60-Day Money Back Guarantee Badge" className="w-40 h-40 md:w-48 md:h-48 object-contain mb-6 drop-shadow-xl" data-id="element-119" />

            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6" data-id="element-120">
              The "Quiet Home" Guarantee
            </h2>

            <div className="space-y-4 text-left max-w-2xl" data-id="element-121">
              <div className="flex items-start gap-3" data-id="element-122">
                <CheckCircle className="w-6 h-6 text-green-500 flex-shrink-0 mt-1" data-id="element-123" />
                <p className="text-lg text-slate-700" data-id="element-124">
                  Try the protocol for{' '}
                  <span className="font-semibold" data-id="element-125">60 days</span>
                </p>
              </div>

              <div className="flex items-start gap-3" data-id="element-126">
                <CheckCircle className="w-6 h-6 text-green-500 flex-shrink-0 mt-1" data-id="element-127" />
                <p className="text-lg text-slate-700" data-id="element-128">
                  If you don't see a{' '}
                  <span className="font-semibold" data-id="element-129">
                    dramatic reduction in barking and destruction
                  </span>
                  , email me
                </p>
              </div>

              <div className="flex items-start gap-3" data-id="element-130">
                <CheckCircle className="w-6 h-6 text-green-500 flex-shrink-0 mt-1" data-id="element-131" />
                <p className="text-lg text-slate-700" data-id="element-132">
                  I'll refund <span className="font-semibold" data-id="element-133">every penny</span>
                  , and you can{' '}
                  <span className="font-semibold" data-id="element-134">keep the books anyway</span>
                </p>
              </div>
            </div>

            <p className="text-xl font-semibold text-slate-900 mt-8" data-id="element-135">
              That's how much I believe in this.
            </p>
          </div>
        </div>
      </motion.div>
    </section>;
}